import React, {useEffect} from "react";
import {inject, observer} from "mobx-react";
import {RootStore} from "../../../stores";
import _ from "lodash";
import styled from '@emotion/styled/macro';
import {Spinner, Variables} from "@enter/core";



export const Webhooks: React.FunctionComponent<{}> = inject('rootStore')(
    observer(
        (props: {}): React.ReactElement => {
            const rootStore: RootStore = _.get(props, 'rootStore');

            const { settingsStore } = rootStore;

            if(!settingsStore.integrationWebhooks) {
                settingsStore.fetchIntegrationWebhooksIfNeeded();
            }

            const SvixIFrame = styled.iframe`
                height: 100%;
                border: none;
                width: 100%;`

            const NotSetupDiv = styled.div`
              padding: 20px;
            `


            if(rootStore && settingsStore.integrationWebhooks) {
                if(settingsStore.integrationWebhooks.url) {
                    return <SvixIFrame src={settingsStore.integrationWebhooks.url}></SvixIFrame>;
                } else {
                    return <NotSetupDiv>Webhooks have not been enabled for your organization. Please contact support for more information.</NotSetupDiv>
                }
            } else {
                return <Spinner/>;
            }

        }
    )
);